import { render, staticRenderFns } from "./veStuIdxScoreConfigShow.vue?vue&type=template&id=10097071&scoped=true"
import script from "./veStuIdxScoreConfigShow.vue?vue&type=script&lang=js"
export * from "./veStuIdxScoreConfigShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10097071",
  null
  
)

export default component.exports